const Success = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
    >
      <circle cx="40" cy="40" r="40" fill="#2D061B" />
      <rect
        width="13.8712"
        height="4.62374"
        rx="2.31187"
        transform="matrix(0.715052 0.699072 -0.715052 0.699072 29.9727 36.2846)"
        fill="#EBB268"
      />
      <rect
        width="23.1187"
        height="4.62374"
        rx="2.31187"
        transform="matrix(-0.715052 0.699072 -0.715052 -0.699072 53.332 33.2323)"
        fill="#EBB268"
      />
    </svg>
  );
};

export default Success;
